export type AmbientBgmPageState = {
  hidden: boolean;
  focused: boolean;
};

export function canPlayAmbientBgm(state: AmbientBgmPageState): boolean {
  return !state.hidden && state.focused;
}

export function currentAmbientBgmPageState(): AmbientBgmPageState {
  return {
    hidden: document.hidden,
    focused: document.hasFocus(),
  };
}
